import { Component, Inject } from '@angular/core';

import { DialogComponentI, DialogData } from '../../dialog/dialog.module';

type Record = { name: string };

type DialogInputData = {
  records: Record[];
};

@Component({
  selector: 'rt-protected-controls-dialog',
  templateUrl: './protected-controls-dialog.component.html',
})
export class ProtectedControlsDialogComponent implements DialogComponentI<{}, boolean> {
  constructor(@Inject(DialogData) public data: DialogInputData) {}

  public trackBy(index: number, report: Record): any {
    return report.name;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(): void {}
}
